const DEPLOYMENT_ERROR_PATTERNS = [
  'module factory is not available',
  'Loading chunk',
  'ChunkLoadError',
  'CSS_CHUNK_LOAD_FAILED',
  'Failed to load chunk',
] as const;

export const isDeploymentError = (error: Error) => {
  const errorSignature = `${error.name} ${error.message}`.toLowerCase();

  return DEPLOYMENT_ERROR_PATTERNS.some((pattern) =>
    errorSignature.includes(pattern.toLowerCase()),
  );
};
